import React, { useRef } from 'react';
// import { AdminContext } from '../../../context/AdminContext';
import { useContext, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';

export default function FileUploader({
  setSelectedFile,
  children,
  id = 'imageUploader',
  accept,
  inputclassname = '',
  extraLabelStyle,
  type = '',
}) {
  const fileInput = useRef(null);

  const {
    // setopenNotificationModalError,
    setNotificationText,
    imageType,
    srtType,
    imageSize,
    srtSize,
    correctTypeSrt,
    correctTypeImage,
    themeColor,
    musicExtension,
    videoSize,
    correctMusicType,
  } = useContext(AdminContext);

  const fileInputRef = useRef(null);
  const [correctType, setCorrectType] = useState(
    type != 'music' ? (accept ? accept : correctTypeImage) : correctMusicType
  );
  // useEffect(() => {
  //   if (accept?.length == 0) {
  //     setCorrectType(correctTypeImage);
  //   } else {
  //     setCorrectType(accept);
  //   }
  // }, [accept]);

  console.log('correctType', correctType, correctMusicType);
  const handleFileInput = (e) => {
    const file = e.target?.files?.[0];
    // const allowedTypeImage = imageType?.findIndex(
    //   (x) => x.mime_type == e.target?.files?.[0]?.type
    // );
    // const allowedTypeSrt = srtType?.findIndex(
    //   (x) => x.mime_type == e.target?.files?.[0]?.type
    // );
    // const allowedTypeMusic = musicExtension?.findIndex(
    //   (x) => x.mime_type == e.target?.files?.[0]?.type
    // );
    // console.log('allowedTypeMusic', allowedTypeMusic);
    setSelectedFile(file);
    // if (type?.length == 0) {
    //   if (correctType == correctTypeSrt) {
    //     if (file?.name?.includes(`${correctTypeSrt}`) == true) {
    //       if (file.size < srtSize) {
    //         console.log('ref', fileInputRef?.current);
    //         setSelectedFile(file);
    //         document.getElementById(`${id}`).value = '';
    //         // fileInputRef?.current?.value=''
    //       } else {
    //         setopenNotificationModalError(true);
    //         setNotificationText({
    //           title: ' آپلود فایل زیرنویس ',
    //           description: `نوع فایل مجاز : ${correctTypeSrt} است. حجم مجاز فایل : ${
    //             srtSize / (1024 * 1024)
    //           } مگابایت است`,
    //         });
    //       }
    //     } else {
    //       setopenNotificationModalError(true);
    //       setNotificationText({
    //         title: ' آپلود فایل ',
    //         description: ` نوع فایل غیر مجاز است `,
    //       });
    //     }
    //   } else {
    //     if (allowedTypeImage == -1) {
    //       setopenNotificationModalError(true);
    //       setNotificationText({
    //         title: ' آپلود فایل ',
    //         description: ` نوع فایل غیر مجاز است `,
    //       });
    //     } else {
    //       if (file.size < imageSize) {
    //         setSelectedFile(file);
    //         // console.log('ref', fileInputRef);
    //         document.getElementById(`${id}`).value = '';
    //         // this.fileInputRef._getText();
    //         // fileInputRef?.current?.value=''
    //         // console.log('inputref', fileInputRef);
    //       } else {
    //         setopenNotificationModalError(true);
    //         setNotificationText({
    //           title: ' آپلود فایل ',
    //           description: `نوع فایل مجاز : ${correctTypeImage} است. حجم مجاز فایل : ${
    //             imageSize / (1024 * 1024)
    //           } مگابایت است`,
    //         });
    //       }
    //     }
    //   }
    // } else {
    //   if (type == 'music') {
    //     if (allowedTypeMusic == -1) {
    //       setopenNotificationModalError(true);
    //       setNotificationText({
    //         title: ' آپلود فایل ',
    //         description: ` نوع فایل غیر مجاز است `,
    //       });
    //     } else {
    //       if (file.size < videoSize) {
    //         setSelectedFile(file);
    //         // console.log('ref', fileInputRef);
    //         document.getElementById(`${id}`).value = '';
    //         // this.fileInputRef._getText();
    //         // fileInputRef?.current?.value=''
    //         // console.log('inputref', fileInputRef);
    //       } else {
    //         setopenNotificationModalError(true);
    //         setNotificationText({
    //           title: ' آپلود فایل ',
    //           description: `نوع فایل مجاز : ${correctType} است. حجم مجاز فایل : ${
    //             imageSize / (1024 * 1024)
    //           } مگابایت است`,
    //         });
    //       }
    //     }
    //   }
    // }
  };

  return (
    <div>
      <input
        // ref={(fileInputRef) => {
        //   this.fileInputRef = fileInputRef;
        // }}
        // ref={fileInputRef}
        className={`${inputclassname} cursor-pointer`}
        type="file"
        onChange={(e) => handleFileInput(e)}
        id={id}
        style={{ display: 'none', cursor: 'pointer' }}
        accept={correctType}
      />
      <label
        htmlFor={id}
        onClick={(e) => fileInput.current}
        className={`cursor-pointer preserveWhiteThemeColor ${extraLabelStyle}`}
      >
        {children}
      </label>
    </div>
  );
}
